import { baseURL } from "./Axios"


const imageURL = `${baseURL}/images/`

export const displayImage = (url) => {
    if (url) {
        return `${imageURL}${url}`
    }
    return
}

export const exportButton = (target) => {
    window.location.href = `${baseURL}/admin/download?target=${target}`
}

export const orderStatus = [
    "placed",
    "processing",
    "cancelled",
    'delivered',
    'en_route',
]


export const formatDateForInput = (date) => {
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    const hours = String(d.getHours()).padStart(2, '0');
    const minutes = String(d.getMinutes()).padStart(2, '0');

    return date ? `${year}-${month}-${day}T${hours}:${minutes}` : new Date().toLocaleString();
};